import { useEffect } from "react";

const ArticleTwo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="pt-32 px-5 pb-20 w-full flex flex-row justify-center">
      <div style={{ maxWidth: 1200 }}>
        <h1
          style={{ color: "#8C191B" }}
          className="text-center lg:text-2xl underline pb-4"
        >
          Legal Update: New Sustainability Bonds Regulations in Tanzania
        </h1>
        <p>
          The{" "}
          <b>
            Capital Markets and Securities (Corporate and Subnational
            Sustainability Bonds) Regulations,
          </b>{" "}
          are officially issued under{" "}
          <b>Government Notice No. 302 on May 23, 2025,</b> according to the
          <b> Capital Markets and Securities Act (Cap. 79).</b> These
          Regulations establish a comprehensive legal framework for the
          issuance, management, and oversight of sustainability- related bonds
          within the United Republic of Tanzania.
        </p>
        {/* segment two Purpose and Scope*/}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Purpose and Scope</p>
          <p>
            The Regulations apply to all issuers of sustainability bonds in
            Tanzania, including both corporate entities and subnational
            government institutions. The key objectives of the framework are to:
          </p>
          <ul className="list-disc list-inside">
            <li>
              Facilitate financing for projects that deliver positive
              environmental and social impacts.
            </li>
            <li>
              Provide structured guidance for the issuance and management of
              sustainability bond proceeds.
            </li>
            <li>
              Enhance financial inclusion, support professional development in
              sustainable finance, and improve capital market liquidity.
            </li>
          </ul>
        </div>
        {/* segment Categories of Sustainability Bonds */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Categories of Sustainability Bonds</p>
          <p>
            The Regulations recognize four types of sustainability-related
            bonds, each with defined criteria and project eligibility
            requirements.
          </p>
          {/* green bons */}
          <div>
            <br />
            <p style={{ color: "#8C191B" }}>a) Green Bonds</p>
            <p>
              Green bonds are designed to finance projects that offer clear
              environmental benefits, including clean energy, biodiversity
              conservation, pollution prevention, and sustainable
              transportation.
            </p>
            <p>
              Issuers must demonstrate robust environmental impact, a
              transparent evaluation process, and strict mechanisms for tracking
              the use of proceeds.
            </p>
          </div>
          {/* blue bons */}
          <div>
            <br />
            <p style={{ color: "#8C191B" }}>b) Blue Bonds</p>
            <p>
              Blue bonds support conservation and sustainable use of marine and
              freshwater ecosystems. Eligible projects include clean water
              treatment, marine biodiversity protection, and eco-tourism
              initiatives. Importantly,proceeds cannot be directed toward oil,
              gas, or seabed mineral extraction activities.
            </p>
          </div>
          {/* Social bons */}
          <div>
            <br />
            <p style={{ color: "#8C191B" }}>c) Social Bonds</p>
            <p>
              These bonds fund projects that enhance access to essential
              services, including infrastructure, education, healthcare,
              housing, and employment generation. Social bonds must specifically
              benefit vulnerable populations, including women, youth, the poor,
              and displaced persons.
            </p>
          </div>
          {/* Social Sustainability-Linked Bonds */}
          <div>
            <br />
            <p style={{ color: "#8C191B" }}>d) Sustainability-Linked Bonds</p>
            <p>
              Unlike project-specific bonds, these are general-purpose bonds
              linked to the issuer's achievement of pre-set sustainability
              performance targets (SPTs). The financial terms of the bond (e.g.,
              interest rate) may vary based on performance against selected Key
              Performance Indicators (KPIs). Independent verification and
              transparent public reporting are mandatory throughout the bond’s
              tenure.
            </p>
          </div>
        </div>

        {/* Key Issuance Requirements */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Key Issuance Requirements</p>
          <p>
            To qualify for issuance, an entity must be legally established in
            Tanzania and meet defined financial criteria, including a minimum
            paid-up capital of TZS 500 million, demonstrated profitability, and
            acceptable debt ratios.
            <br />
            Issuers must obtain prior approval from the Capital Markets and
            Securities Authority (CMSA) and submit a comprehensive prospectus
            along with a sustainability bond framework.
          </p>
        </div>

        {/* Management, Reporting, and Governance */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>
            Management, Reporting, and Governance
          </p>
          <p>
            Proceeds from the bonds must be allocated exclusively to eligible
            projects and held in trust accounts at licensed custodian banks.
            Issuers are required to maintain robust internal tracking systems
            and publish annual progress reports detailing fund allocation,
            project performance, and environmental or social impacts.
            <br className="pb-10" />
            External reviews are compulsory both before and after issuance,
            conducted by CMSA-recognized reviewers. Reviewers are limited to two
            consecutive three-year terms per project to ensure objectivity. The
            CMSA also retains enforcement authority, including the right to
            revoke a bond’s sustainability label in cases of greenwashing or
            regulatory non-compliance.
          </p>
        </div>

        {/* Supporting Framework and Disclosure */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>
            Supporting Framework and Disclosure
          </p>
          <p>
            The Regulations include a detailed Schedule outlining operational
            prerequisites, such as the contents of offer documents, the
            appointment of advisers and placing agents, publication timelines,
            and financial disclosures.
            <br className="pb-10" />
            Issuers must comply with specific requirements to ensure
            transparency, investor protection, and risk awareness.
          </p>
        </div>
        {/* Conclusion */}
        <div>
          <br />
          <p style={{ color: "#8C191B" }}>Conclusion</p>
          <p>
            The 2025 Sustainability Bonds Regulations mark a significant step
            forward in advancing sustainable finance in Tanzania. By providing a
            structured and transparent legal framework, the CMSA aims to attract
            responsible investment, enhance capital market resilience, and align
            with global trends in environmental, social, and governance (ESG)
            investing.
          </p>
          <br />
          <i style={{ color: "#8C191B" }}>
            "This legal update is provided for general information purposes and
            does not constitute any legal advice. For tailored legal advice,
            please contact our team for assistance."
          </i>
        </div>
      </div>
    </div>
  );
};

export default ArticleTwo;
